import React from "react";
import { IconTextButtonStyles } from "./IconTextButtonStyles";

const IconTextButton = ({ onClick, buttonText, Icon, variant, color, iconProps, ...props }) => {
    return (
        <IconTextButtonStyles
            onClick={onClick}
            variant={variant || 'contained'}
            color={color || 'primary'}
            {...props}  // Spread remaining props here
        >
            <Icon className='btnIcon' {...iconProps}/>
            {buttonText}
        </IconTextButtonStyles>
    );
};

export default IconTextButton;